module.exports = __webpack_public_path__ + "img/product-2.5779f08b.jpeg";